import { render } from "./UploadSermon.vue?vue&type=template&id=070711e7&scoped=true"
import script from "./UploadSermon.vue?vue&type=script&lang=js"
export * from "./UploadSermon.vue?vue&type=script&lang=js"

import "./UploadSermon.vue?vue&type=style&index=0&id=070711e7&scoped=true&lang=scss"
import "./UploadSermon.vue?vue&type=style&index=1&id=070711e7&scoped=true&lang=css"
import "./UploadSermon.vue?vue&type=style&index=2&id=070711e7&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070711e7"]])

export default __exports__